import React from "react";

/**
 * Standard page header for module pages. Renders a title (and optional
 * eyebrow + description) on the left, and arbitrary actions on the right.
 */
export function PageHeader({ eyebrow, title, description, actions, testid = "phx-page-header" }) {
  return (
    <div data-testid={testid} className="flex flex-wrap items-start justify-between gap-4 mb-5">
      <div>
        {eyebrow && (
          <p className="text-xs font-semibold text-[var(--phx-brand-primary)] mb-1">
            {eyebrow}
          </p>
        )}
        <h1
          data-testid={`${testid}-title`}
          style={{ fontFamily: "var(--phx-font-sans)" }}
          className="text-2xl font-semibold tracking-tight leading-tight"
        >
          {title}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-[var(--phx-brand-secondary)] max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
